export default "__VITE_ASSET__CzXiKSpX__"